import cx from 'classnames';
import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../index.module.scss';

const FeedbackQuestionsRenderer = (props: { questionText: string; answerText: string }) => {
  const { questionText, answerText } = props;
  return (
    <div className="flex flex-row w-full mt-3">
      <Typography variant="p5" color="var(--grayscale-content-3)" className="basis-[50%]">
        {questionText}
      </Typography>
      <Typography
        variant="p5"
        color="var(--grayscale-content-1)"
        className={cx(styles.wordBreak, 'basis-[50%] text-end')}
      >
        {answerText}
      </Typography>
    </div>
  );
};

export default FeedbackQuestionsRenderer;
